import React, { useEffect } from 'react';
import {
  ThemeProvider,
  CssBaseline,
  Box
} from '@material-ui/core';
import { Box as AWSUIBox, Container as AWSUIContainer } from '@amzn/awsui-components-react-v3';
import { websiteViewTheme } from './styles/theme';
import { useAppLayoutStyles } from './styles/app-layout.styles';
import './styles/page-shell.scss';
import { WebsiteSelector } from './selector';
import { WebsiteMetadata } from './metadata';
import { PrimitiveMetrics } from './primitive-metrics';
import { TimelineView } from './timeline-view';
import { WebsiteSummary } from './website-summary';
import { WebsiteHeader } from './website-header';
import { FunnelPanel } from '../shared-panels/FunnelPanel';
import { metricFeaturesList, metricPageNames } from 'src/constants/swo-ui-metric-constants';
import { SwoUiMetrics } from 'src/utils/swo-ui-metrics/swo-ui-metrics';
import { UrlHelper } from '../../utils/url-helper';

export const WebsiteViewLayout = React.memo(() => {
    const classes = useAppLayoutStyles();
    const website = UrlHelper.getParamValue('website');
    const websiteId = UrlHelper.getParamValue('websiteId');
    // The funnel panel is built but not announced, so it renders only for ?release=v1. Absent or any
    // other value keeps it hidden, which is what everyone reaching the page today gets.
    const showFunnelPanel = UrlHelper.getParamValue('release') === 'v1';

    useEffect(() => {
        SwoUiMetrics.publishCloudWatchCountMetric(metricPageNames.websiteView, metricFeaturesList.websiteAnalysisAndDiagnosticTool);
    }, [])

    return (
        <ThemeProvider theme={websiteViewTheme}>
            <CssBaseline />
            {/* The selector shares the page's centred column so it lines up with the panels below it,
                rather than running the full width above a 1180px column. */}
            <Box className="ovp-page">
                <Box className="ovp-page__wrap">
                    <AWSUIContainer header={
                        <AWSUIBox variant="h2" padding={{ top: "m" }}>
                        Website Flow Analysis & Diagnostic Tool
                    </AWSUIBox>
                    }>
                        <WebsiteSelector />
                    </AWSUIContainer>

                    {/* Main Content */}
                    <Box
                        component="main"
                        className={classes.mainContent}
                    >
                        {/* The header captions the funnel, so it is gated with it rather than separately:
                            on its own above the existing page it would duplicate the metadata card below
                            for no gain. */}
                        {showFunnelPanel && websiteId && (
                            <>
                                <WebsiteHeader />
                                <Box className={classes.cardContainer}>
                                    <FunnelPanel scope={{ type: 'WEBSITE', websiteId: websiteId }} />
                                </Box>
                            </>
                        )}

                        <Box className={classes.cardContainer}>
                            <WebsiteSummary />
                        </Box>

                        {/* Timeline Section - Full Width */}
                        {<Box className={`${classes.timelineSection} ovp-page__mui-panel`}>
                            <TimelineView />
                        </Box>}

                        {/* EWC Metadata Section */}
                        <Box className={`${classes.cardContainer} ovp-page__mui-panel`}>
                            <WebsiteMetadata />
                        </Box>

                        {/* Primitive Metrics Section - Full Width */}
                        <Box className={classes.cardContainer}>
                            <PrimitiveMetrics />
                        </Box>

                    </Box>
                </Box>
            </Box>
        </ThemeProvider>
    );
});

WebsiteViewLayout.displayName = 'WebsiteViewLayout';
